import { Arrange, Container, Spacer, Text } from '@loomhq/lens';
import moment from 'moment';
import React from 'react';
import { useDispatch } from 'react-redux';

import { LARGE_TABLET_MAX_WIDTH } from 'constants/breakpoints';
import { ROLLOUT_DESTINATION_PUBLISH_BASIC } from 'constants/featureFlag';
import { updateLocalVideoCreator } from 'creators/shareVideo';

import ShareButtonsWrapper from '../share-video/share-buttons';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';
import MediaQuery from 'components/media-query';
import { VideoVisibility } from 'components/placeholder-video-card/video-visibility';
import UserAvatar from 'components/user-avatar';
import ProfileCard from 'components/user-profile/profile-card';

const OwnerInfo = ({
  currentUserIsOwner,
  customLogoUrl,
  date,
  name,
  user,
  userAvatarSrc,
  video = {},
}) => {
  const reduxDispatch = useDispatch();

  return (
    <Spacer top="medium" bottom="small">
      <Arrange gap="small" justifyContent="space-between">
        <Arrange alignItems="center" gap="medium">
          {window.loomSSRVideo ? (
            <ProfileCard
              avatarSrc={userAvatarSrc}
              hasFocus={false}
              name={name}
              useLoomSSRVideo
            >
              <UserAvatar
                avatarSize={6}
                avatarSrc={userAvatarSrc}
                name={name}
              />
            </ProfileCard>
          ) : (
            <UserAvatar
              altText={`${name}’s avatar`}
              avatarSize={6}
              avatarSrc={userAvatarSrc}
              name={name}
            />
          )}
          <Container overflow="hidden">
            {window.loomSSRVideo ? (
              <div className="inlineFlex">
                <ProfileCard
                  avatarSrc={userAvatarSrc}
                  hasFocus={true}
                  name={name}
                  useLoomSSRVideo
                >
                  <Text fontWeight="bold" hasEllipsis>
                    {name}
                  </Text>
                </ProfileCard>
              </div>
            ) : (
              <Text fontWeight="bold" hasEllipsis>
                {name}
              </Text>
            )}
            <Arrange autoFlow={{ default: 'row', medium: 'column' }}>
              <Text hasEllipsis>{moment(date).format('LL')}</Text>
              {video && (
                <FeatureFlaggedComponent
                  flag={ROLLOUT_DESTINATION_PUBLISH_BASIC}
                  activationValues={[true]}
                >
                  <Text color="bodyDimmed">
                    <span className="none md-inline">・</span>
                    <VideoVisibility
                      videoId={video.id}
                      videoVisibility={video.visibility}
                      onVisibilityUpdate={newVisibility => {
                        reduxDispatch(
                          updateLocalVideoCreator(video, {
                            visibility: newVisibility,
                          })
                        );
                      }}
                      currentUserCanEdit={video.currentUserCanEdit}
                    />
                  </Text>
                </FeatureFlaggedComponent>
              )}
            </Arrange>
          </Container>
        </Arrange>
        {user && ( // we check this to only show on the new share page
          <MediaQuery query={`(max-width: ${LARGE_TABLET_MAX_WIDTH}px)`}>
            <ShareButtonsWrapper
              className="ml:auto relative"
              currentUserIsOwner={currentUserIsOwner}
              user={user}
              video={video}
            />
          </MediaQuery>
        )}
        {customLogoUrl && (
          <img src={customLogoUrl} className="custom-brand-logo ml:small" />
        )}
      </Arrange>
    </Spacer>
  );
};

export default OwnerInfo;
